const ONLINE_CHECK_TIMEOUT_MS = 5000;
const ONLINE_CHECK_PATH = "/up";

// For user-blocking interactions (e.g. starting a route) where a too-slow
// connection should quickly fall back to the offline/cache path.
const QUICK_ONLINE_CHECK_TIMEOUT_MS = 2500;

export const quickCheckOnlineStatus = () =>
  checkOnlineStatus({ timeoutMs: QUICK_ONLINE_CHECK_TIMEOUT_MS });

export const checkOnlineStatus = async ({
  timeoutMs = ONLINE_CHECK_TIMEOUT_MS,
} = {}) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const online = await fetch(ONLINE_CHECK_PATH, {
      cache: "no-store",
      credentials: "same-origin",
      method: "HEAD",
      signal: controller.signal,
    });
    const isOnline = online.status >= 200 && online.status < 300;
    updateOnlineStatus(isOnline);
    return isOnline;
  } catch (err) {
    updateOnlineStatus(false);
    return false; // offline, or connection too slow/stalled to be usable
  } finally {
    clearTimeout(timeoutId);
  }
};

function updateOnlineStatus(isOnline) {
  const onlineIcon = document.getElementById("online-icon");
  const offlineIcon = document.getElementById("offline-icon");

  if (!onlineIcon || !offlineIcon) return;

  if (isOnline) {
    onlineIcon.classList.remove("hidden");
    offlineIcon.classList.add("hidden");
  } else {
    onlineIcon.classList.add("hidden");
    offlineIcon.classList.remove("hidden");
  }
}
